import type { ScreenshotOptions } from "./types.ts";

/**
 * Captures a screenshot from the given browser page and stores it using
 * the provided storage strategy. Emits a discovery log line that the
 * Synthetic Monitoring frontend uses to detect and render thumbnails.
 */
export async function captureScreenshot(
  page: { screenshot: (opts?: { fullPage?: boolean }) => Promise<ArrayBuffer> },
  options: ScreenshotOptions,
): Promise<void> {
  const { caption = "", fullPage = false, store } = options;

  const buffer = await page.screenshot({ fullPage });
  const uuid = crypto.randomUUID();

  await store.upload(buffer, uuid, caption);
}
